import { components } from 'type/ReportServiceSchema';

export type OpinionQuestionDto = components['schemas']['OpinionQuestion'];

export type OpinionQuestionModel = {
  id: number;
  content: string;
};

export const mapOpinionQuestionDtoToModel = (dto: OpinionQuestionDto): OpinionQuestionModel => ({
  id: dto.id,
  content: dto.content,
});
